export default {
    list_total_year: []
};